import { moment } from "ngx-bootstrap/chronos/test/chain";
import { EntityQuery } from "./entity.query.model";
import { ParticipatingBrandResult } from "./participant-brand-dto";
import { ProgramFundingListItemDto } from "./programs.model";

export class TacticCatalogListItemDto {
    public id: number;
    public campaignThemeId: number;
    public userId: number;
    public tacticId: number;
    public tacticTacticName: string;
    public tacticTacticDesc: string;
    public tacticDocumentId: number;
    public tacticTacticProductionOptionId: number;
    public tacticFlatCost: number;
    public tacticMinimumQuantity: number;
    public tacticMaximumQuantity: number;
    public createdDate: Date;
    public createdBy: number;
    
}

export class SaveProgramTacticCommand {
    programTactic: ProgramTacticDto;
}

export class ProgramTacticDto {
    public id: number;
    public programId: number;
    public description: string;
    public tacticTypeId: number;
    public beginDate: Date;
    public endDate: Date;
    public tacticStartDate: Date;
    public tacticEndDate: Date;
    public shopTypeId: number;
    public orderQuantity: number;
    public totalCost: number;
    public tacticDeliveryMethodId: number;
    public tacticDeliveryMethodName: string;
    public tacticTypeTacticDocumentTypeId: number;
    public documentId: number;
    public programTacticComponent: ProgramTacticComponent[];
    public totalAtlBtlCost: number;
    public tacticProductTypeId: number;
    public tacticProductionOptionId: number;
    public tacticName: string;

    constructor() {
        this.programTacticComponent = new Array<ProgramTacticComponent>();
    }

    public static fixDates(obj: ProgramTacticDto): ProgramTacticDto {
        obj.tacticStartDate = obj.tacticStartDate == null ? null : moment(obj.tacticStartDate).toDate();
        obj.tacticEndDate = obj.tacticEndDate == null ? null : moment(obj.tacticEndDate).toDate();
        obj.beginDate = obj.beginDate == null ? null : moment(obj.beginDate).toDate();
        obj.endDate = obj.endDate == null ? null : moment(obj.endDate).toDate();

        return obj;
    }
}
export class ProgramTacticComponent {
    public id: number;
    public programTacticID: number;
    public componentTypeID: number;
    public componentDesc: string;
    public expenseClassID: number;
    public mediaTypeID: number;
    public vendorID: number;
    public subVendorId: number;
    public chargeCode: string;
    public promoCodeRequired: boolean;
    public couponCodeRequired: boolean;
    public couponCode: string;
    public couponExpDate: Date;
    public couponStartDate: Date;
    public barcodeDestinationID: number;
    public barCodeDueDate: Date;
    public faceValue: string;
    public faceValueType: string;
    public purchaseUnitRequirement: string;
    public includedProductRange: string;
    public targetingCriteria: string;
    public circulation: string;
    public estRedemptionPercent: string;
    public atl: number;
    public btl: number;
    public version: number;
    public promoCode: string;
    public beginDate: number;
    public endDate: number;
    public po: number;
    public do: number;
    public files: Array<any>;
    public vendorName: string;
    public subVendorName: string;
    public couponType: string;
    public fundings: ParticipatingBrandResult;
}

export class TacticDto {
    public availableStock: number;
    public tacticName: string;
    public tacticDesc: string;
    public id: number;
    public documentId: number;
    public tacticProductionOptionId: number;
    public flatCost: number;
    public minimumQuantity: number;
    public maximumQuantity: number;
    public tacticProductionOptionName: string;
    public totalCost: number;
    public tacticUnitCost: tacticUnitCost[];
    public tacticDeliveryMethodName: string;
    public inventoryFound: boolean;
    public createdAt: Date;
    public uproduceDocId: number;
    public documentTypeId: any;
    public tacticOutputTypeId: any;
    public manufacturerId: any;
    public tacticProductTypeId: any;
    public productionProcessingId: any;
    public outputFileName: string;
    public fileExtension: string;
    public isActive: boolean;
    uProduceOutputTypeId: any;
    public productionProcessingName: string;
    public uProduceOutputTypeName: string;
    public manufacturerName: string;
    public tacticProductTypeName: string;
    public tacticDocumentTypeName: string;
    documentFileName: string;
    public campaigns: Array<{id: number, name: string}>;
    public categories: Array<{id: number, name: string}>;
    public keywords: Array<{id: number, name: string}>;
    public customizations: Array<{id: number, name: string}>;
    public itemSku: string;
    public itemDescription: string;
    public addSku: boolean;
    public isParentTactic: boolean;
    public parentId: number;
    public parentName: string;

    constructor() {
        this.tacticUnitCost = new Array<tacticUnitCost>();
    }
}

export class tacticUnitCost {
    public id: number;
    public tacticId: number;
    public costPerUnit: number;
    public fromValue: number;
}

export class TacticCatalogSearch extends EntityQuery {
    public nameContains: string;
    public descriptionContains: string;
    public campaignThemeId: number;
    public id: number;
    public tacticCategoryID = 0;
}

export class CreateTacticCategoryCommand
{
    public name: string;
}

export class TacticId {
    constructor(public id: number) {

    }
}

export class TacticCampaignProgramDescriptionDto {
    public id: number;
    public retailerId: number;
    public campaignThemeName: string;
    public campaignThemeId: number;
    public description: string;
    public retailerName: string;
    public name: string;
    public programStartDate: Date;
    public programEndDate: Date;
    public fiscalYear: number;
    public strategicBusinessInitiativeName: string;
    public campaignThemeDocumentId: number;
    public programFunding: ProgramFundingListItemDto[];
    public statusId: number;
    public canApprove: boolean;
    public canSubmit: boolean;
    public canEdit: boolean;
    public fileUrl: string;
    public createdBy: string;
    public campaignThemeTypeID: number;
    public atl: number;
    public atlFormatted: string;
    public btl: number;
    public btlFormatted: string;
    public totalAtlBtl: number;
    public totalFormatted: string;
    public programChangeReasonID: number;
    public note: string;
    public deliveryDate: Date;

    constructor() {
        this.programFunding = new Array<ProgramFundingListItemDto>();
    }
}

export class ProductionOptionLookupItemDto {
    public id: number;
    public name: string;
    public createdDate: Date;
    public createdBy: number;
}

export class DeliveryMethodLookupItemDto {
    public id: number;
    public name: string;
    public createdDate: Date;
    public createdBy: number;
}

export class ProgramTacticId {
    constructor(public value: number) {

    }
}

export class ProgramTacticCartSummaryDto {
    public id: number;
    public count: number;
    public hasCustomization: boolean;
    public cartTotalFormatted: string;
    public cartTotal: number;
    public programFundingTotalFormatted: string;
    public programFundingTotal: number;
}

export class TacticAssetslistItemDTO {
    public id: number;
    public userId: number;
    public tacticId: number;
    public tacticTacticName: string;
    public tacticTacticDesc: string;
    public tacticTacticDocumentTypeId: number;
    public tacticTacticProductionOptionId: number;
    public tacticFlatCost: number;
    public tacticMinimumQuantity: number;
    public tacticMaximumQuantity: number;
    public tacticDocumentId: number;
    public createdDate: Date;
    public createdBy: number;
    public modifiedDate: Date;
    public modifiedBy: number;
    public DownloadURL: string;
    public placeholder: boolean;
}

export class TacticSearch extends EntityQuery {
    public themeCategoryContains: string;
    public nameContains: string;
    public brandContains: string;
    public keywordContains: string;
    public themeCategoryId: number;
    public id: number;
}



// WEBPACK FOOTER //
// ./src/app/client-core/dtos/tactics.model.ts